import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const CardWithTopLine: React.FC<Props> = ({ children }) => (
  <div className='flex flex-col'>
    <div className='bg-primary h-4 shrink-0 rounded-t-2xl' />
    <div className='border-primary-200 flex-grow rounded-b-2xl border-2 border-t-0 bg-white px-4 pt-2 pb-4'>{children}</div>
  </div>
);

export default CardWithTopLine;
